"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_USER_EMAIL_VERIFICATION = void 0;
const client_1 = require("@apollo/client");
exports.SEND_USER_EMAIL_VERIFICATION = client_1.gql `
  mutation sendUserEmailVerification($token: String!) {
    sendUserEmailVerification(token: $token)
  }
`;
